import { get, post, del, delWithBody, upload } from '../request';

export async function fetchDocumentList(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/documentlist/${propertyId}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchGlobalDocumentList(
  { equityfinderService },
  authenticationToken,
) {
  const url = `${equityfinderService}/equityfinder/globaldocumentlist`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteDocument(
  { equityfinderService },
  authenticationToken,
  { documentId },
) {
  const url = `${equityfinderService}/equityfinder/property/document/${documentId}`;
  const { body } = await delWithBody(authenticationToken, url, {
    contentType:
      'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  });
  return body;
}

export async function getDocument(
  { equityfinderService },
  authenticationToken,
  { documentId },
) {
  const url = `${equityfinderService}/equityfinder/property/document/${documentId}/object`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
}

export async function getGlobalDocument(
  { equityfinderService },
  authenticationToken,
  { documentId },
) {
  const url = `${equityfinderService}/equityfinder/global/document/${documentId}/object`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
}

export async function deleteGlobalDocument(
  { equityfinderService },
  authenticationToken,
  { documentId },
) {
  const url = `${equityfinderService}/equityfinder/global/document/${documentId}`;
  const { body } = await delWithBody(authenticationToken, url, {
    contentType:
      'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  });
  return body;
}

export async function uploadGlobalDocument(
  { equityfinderService },
  authenticationToken,
  { data },
) {
  const url = `${equityfinderService}/equityfinder/globaldocumentlist`;
  const { body } = await upload(authenticationToken, url, data);
  return body;
}

export async function uploadDocument(
  { equityfinderService },
  authenticationToken,
  { data, propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/documentlist/${propertyId}/${year}`;
  const { body } = await upload(authenticationToken, url, data);
  return body;
}

export async function addGlobalDocument(
  { equityfinderService },
  authenticationToken,
  { propertyId, year, documentIds },
) {
  const url = `${equityfinderService}/equityfinder/property/presentationlist/${propertyId}/${year}`;
  const { body } = await post(authenticationToken, url, {
    globalDocumentIDList: documentIds,
  });
  return body;
}

export async function addPublishedDocument(
  { equityfinderService },
  authenticationToken,
  { propertyId, year, documentIds },
) {
  const url = `${equityfinderService}/equityfinder/property/presentationlist/${propertyId}/${year}`;
  const { body } = await post(authenticationToken, url, {
    publishedDocumentIDList: documentIds,
  });
  return body;
}

export async function deletePresentation(
  { equityfinderService },
  authenticationToken,
  { presentationId },
) {
  const url = `${equityfinderService}/equityfinder/property/presentation/${presentationId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function publishPresentation(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/presentation/${propertyId}/${year}/final`;
  const { body } = await post(authenticationToken, url, undefined, {
    contentType:
      'multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW',
  });
  return body;
}

export async function previewPresentation(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/presentation/${propertyId}/${year}/final`;
  const { body } = await post(
    authenticationToken,
    url,
    { preview: true },
    { outputType: 'bytearray' },
  );
  return body;
}

export async function fetchPresentation(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/presentationlist/${propertyId}/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchFinalPresentation(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/presentation/${propertyId}/${year}/final`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getFinalDocument(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/presentation/${propertyId}/${year}/final/object`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray',
  });
  return body;
}

export async function orderChange(
  { equityfinderService },
  authenticationToken,
  { propertyId, year, ids },
) {
  const url = `${equityfinderService}/equityfinder/property/presentation/${propertyId}/${year}/setorder`;
  const { body } = await post(authenticationToken, url, {
    presentationList: ids,
  });
  return body;
}

export async function fetchDefaultTemplate(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/${propertyId}/${year}/reporttemplate`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function creatTemplates(
  { equityfinderService },
  authenticationToken,
  { propertyId, year, versionId },
) {
  const url = `${equityfinderService}/equityfinder/property/${propertyId}/${year}/${versionId}/createtemplate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function clearDocuments(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/documentlist/${propertyId}/${year}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function clearPresentations(
  { equityfinderService },
  authenticationToken,
  { propertyId, year },
) {
  const url = `${equityfinderService}/equityfinder/property/presentationlist/${propertyId}/${year}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
